module.exports = __webpack_public_path__ + "img/momo_button_redeem_record.0de73217.png";